import { CpReceiptsRequestInterface } from '../../../interfaces/request/receipts/cp-receipts-request-interface';

export class CpReceiptsRequestModel implements CpReceiptsRequestInterface {
  EndDate: string = '';
  Page: number = 1;
  PageSize: number = 5;
  ReceiptNumber: string = '';
  StartDate: string = '';
  State: string = '';

  constructor(init?: Partial<CpReceiptsRequestModel>) {
    Object.assign(this, init);
  }
}
